module.exports = __webpack_public_path__ + "static/media/logo_one_slim.d4695e46.png";